module.exports = __webpack_public_path__ + "static/media/Client_1_ AWM_logo.c527f558.png";